import { FormInstance } from 'antd'
import { InternalNamePath } from 'antd/lib/form/interface'
import { showToast } from 'common/utils'

export const handleOnFinishFailed = (
  errorFields: {
    name: InternalNamePath
    errors: string[]
  }[]
) =>
  errorFields.map((errorField) =>
    errorField.errors.map((err) => showToast({ title: err, type: 'error' }))
  )

export const handleSubmit = async (
  form: FormInstance,
  handleOnFinish: (values: any) => Promise<void>
) => {
  try {
    const values = await form.validateFields()
    await handleOnFinish(values)
  } catch (errorInfo) {
    const error = errorInfo as {
      errorFields: { name: string[]; errors: string[] }[]
    }
    handleOnFinishFailed(error.errorFields)
  }
}

export const cleanDecimalValues = (value?: number) =>
  value ? Math.round(value || 0).toString() : ''

export const getMaxValueValidator = async (
  value: string,
  error: string,
  maxValue?: number
) => {
  if (!value) {
    return
  }

  if (maxValue && +value > maxValue) {
    throw new Error(error)
  }
}
